import React from "react";
import ReactDOM from "react-dom/client";

// Bootstrap подключается ДО App.css: иначе его базовые правила (заголовки,
// ссылки, таблицы) перебивают стили макета.
import "bootstrap/dist/css/bootstrap.min.css";
import "./i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
// Единая система кнопок — подключается последней, чтобы токены и состояния
// (.ui-btn / .button-default) не перебивались старыми правилами.
import "./components/ui/ui.css";
// Единый вид документов медкарты (экран): перекрывает локальные стили
// первичного/повторного осмотра, анамнеза и умной диагностики.
import "./modules/patient/medcardDoc.css";
import logoImg from "./media/logo_img_big2.png";

const setFavicon = (icon) => {
    const link =
        document.querySelector("link[rel~='icon']") || document.createElement("link");
    link.rel = "icon";
    link.href = icon;
    document.head.appendChild(link);
};

setFavicon(logoImg);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
